import { observer } from "mobx-react";
import { LoginView as Login2 } from "./loginComponents";
import { useLoginModel } from "./loginDomain";

const LoginPage = observer(function LoginPage() {
  const model = useLoginModel();
  return <Login2 model={model} />;
});

export default LoginPage;
